import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'vectronic-three-panel-layout',
  templateUrl: './three-panel-layout.component.html',
  styleUrls: ['./three-panel-layout.component.scss'],
  imports: [MatIconModule, MatButtonModule],
})
export class ThreePanelLayoutComponent {
  showLeftPanel = input<boolean>(true);
  showRightPanel = input<boolean>(true);
  isLeftCollapsed = false;
  isRightCollapsed = false;

  collapseLeft() {
    this.isLeftCollapsed = true;
  }
  expandLeft() {
    this.isLeftCollapsed = false;
  }
  collapseRight() {
    this.isRightCollapsed = true;
  }
  expandRight() {
    this.isRightCollapsed = false;
  }

  toggleLeft() {
    this.isLeftCollapsed = !this.isLeftCollapsed;
  }
  toggleRight() {
    this.isRightCollapsed = !this.isRightCollapsed;
  }
}
